import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainContainer } from './container/main/main.component';
import { QueueContainerComponent } from './container/queue-container/queue-container.component';
import { SelfServiceComponent } from './container/self-service/self-service.component';
import { QueueGuardGuard } from './guards/queue-guard.guard';
import { SettingsResolver } from './settings/settings-resolver';
import { SettingsComponent } from './settings/settings.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ServerUrlGuard } from './guards/server-url.guard';

const routes: Routes = [
	{
		path: '',
		component: MainContainer,
		canActivateChild: [ServerUrlGuard],
		children: [
			{
				path: ':client/panel',
        canActivate: [QueueGuardGuard],
				loadChildren: () => import('./modules/panel/panel.module').then(m => m.PanelModule)
			}
		]
	},
	{
		path: '',
		component: MainContainer,
		canActivateChild: [ServerUrlGuard],
		children: [
			{
				path: ':client/painel',
        canActivate: [QueueGuardGuard],
				loadChildren: () => import('./modules/panel/panel.module').then(m => m.PanelModule)
			},
			{
				path: ':client/painel/:id',
        canActivate: [QueueGuardGuard],
				loadChildren: () => import('./modules/panel/panel.module').then(m => m.PanelModule)
			}
		]
	},
	{
		path: '',
		component: SelfServiceComponent,
    canActivateChild: [ServerUrlGuard],
		children: [
			{
				path: ':client/totem',
        canActivate: [QueueGuardGuard],
				loadChildren: () => import('./modules/totem/totem.module').then(m => m.TotemModule)
			}
		]
	},
	{
		path: '',
		component: QueueContainerComponent,
    canActivateChild: [ServerUrlGuard],
		children: [
			{
				path: ':client/fila-de-atendimento',
        canActivate: [QueueGuardGuard],
				loadChildren: () => import('./modules/queue/queue.module').then(m => m.QueueModule)
			}
		]
	},
	{
		path: 'indisponivel',
		component: UnauthorizedComponent
	},
	{
		path: ':client/settings',
    canActivate: [ServerUrlGuard],
		resolve: {
			params: SettingsResolver
		},
		component: SettingsComponent,
	},
	{
		path: ':client/settings/:auth',
    canActivate: [ServerUrlGuard],
		resolve: {
			params: SettingsResolver
		},
		component: SettingsComponent,
	},
	{
		path: '',
		component: SelfServiceComponent,
		children: [
			{
				path: 'confirmacao',
				loadChildren: () => import('./modules/confirmation/confirmation.module').then(m => m.ConfirmationModule)
			}
		]
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
